import { reducerTypes } from './types';
import { IAuth } from '../../interfaces/auth';

export const loadingAction = () => ({
  type: reducerTypes.LOADING,
});

export const loginAction = (data: IAuth) => ({
  type: reducerTypes.LOGIN,
  payload: data,
});

export const logoutAction = () => ({
  type: reducerTypes.LOGOUT,
});
